/* eslint-disable sonarjs/new-cap */
import { Deviance } from '../types';
import { ApiRepository } from './main repository/api.repository';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace DevianceService {
  const BASE_API = `${window.globalConfiguration.api.obsolescence}/v1`;

  export const updateVersionDeviance = async (versionId: number, payload: Deviance.UpdateDTO) => {
    return ApiRepository.Core().patch<Deviance.UpdateDTO, unknown>(
      `${BASE_API}/deviances/version/${versionId}`,
      payload
    );
  };

  export const deleteVersionDeviance = async (versionId: number) => {
    return ApiRepository.Core().delete(`${BASE_API}/deviances/version/${versionId}`);
  };

  export const applyDevianceToComponent = async (componentRefId: number, payload: Deviance.UpdateDTO) => {
    return ApiRepository.Core().put<Deviance.UpdateDTO, { updated: number }>(
      `${BASE_API}/deviances/component/${componentRefId}`,
      payload
    );
  };
}
